import { Controller, useFormContext } from "react-hook-form";
import * as myconst from "../../constants/index"
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";
import { useEffect } from "react";

interface arr_type {
  value: string;
  label: string;
}

const StepOne = ({ handleNext, goOnLast, isLinear, methods, setErrorSteps }: any) => {

  const { register, getValues, setValue, watch, formState: { errors }, control, trigger, clearErrors } = useFormContext();
  const niche_topics_value = watch('niche_topics');
  const content_focus_value = watch('content_focus');
  const handleNextButton = async () => {
    let isValid: boolean = false;
    isValid = await trigger(['niche_topics', 'content_focus', 'unique_expertise']);

    if (isValid) {
      handleNext();
    } else {
      const errorFields = Object.keys(errors);
      if (errorFields.length > 0) {
        const errorField = errorFields[0];
        const fieldElement = document.querySelector(`input[name=${errorField}]`);
        if (fieldElement) {
          (fieldElement as HTMLElement)?.focus();
        } else {
          console.warn(`Field with name ${errorField} not found`);
        }
      }
    }
  }
  const getFormErrorMessage = (name: string) => {
    return (
      errors[name] && (
        <small className="p-error">{errors[name]?.message?.toString()}</small>
      )
    )
  }
  const finalError = Object.keys(errors).length
  useEffect(() => {
    setErrorSteps(Object.keys(errors).map((keys: string) => (myconst.findStepWhichAreIncomplete(keys))).filter((item, index) => Object.keys(errors).map((keys: string) => (myconst.findStepWhichAreIncomplete(keys))).indexOf(item) === index))
  }, [finalError])
  return (
    <div className='step-preview-wrap'>
      <div className='stepper-main_butter_pie'>
        <div className='stepper-form'>
          <div className='stepper-wrapper'>
            <div className='form-row'>
              <div className='form-col'>
                <label className="form-label fw-bold">What topics are you passionate about?</label>
                <Controller
                  name="niche_topics"
                  control={control}
                  rules={{ required: "Please select a topic" }}
                  render={({ field: { value, onChange } }) => (
                    <>
                      {myconst.getCheckboxOptions('niche_topics').map((option: arr_type) => {
                        // Check if the current option is selected
                        // Ensure value is an array
                        const currentValue = Array.isArray(value) ? value : [];
                        // Check if the current option is selected
                        const isChecked = currentValue.includes(option.value);

                        // Toggle the option in the array
                        const toggleOption = () => {
                          clearErrors("niche_topics");
                          let updated = [...currentValue];
                          if (updated.includes(option.value)) {
                            updated = updated.filter((v) => v !== option.value);
                          } else {
                            updated.push(option.value);
                          }
                          onChange(updated);
                        };

                        return (
                          <div key={option.value} className="p-field-checkbox d-flex align-items-center">
                            <Checkbox
                              inputId={'niche_topics'}
                              value={option.value}
                              checked={isChecked}
                              onChange={(e) => {
                                // If checked, add the value to the array; otherwise, remove it
                                clearErrors('niche_topics');
                                let updated = [...value];
                                if (e.checked) {
                                  updated.push(option.value);
                                } else {
                                  updated = updated.filter((v) => v !== option.value);
                                }
                                onChange(updated);
                              }}
                            />
                            <label className="ms-2 c-pointer" onClick={toggleOption} htmlFor={option.value} style={{ marginLeft: "0.5rem" }}>
                              {option.label}
                            </label>
                            {option.label === 'Other' && niche_topics_value?.includes('other') &&
                              <InputText style={{ fontSize: "14px" }} className="ms-4" {...register("niche_topics_other")} />
                            }
                          </div>
                        );
                      })}
                    </>
                  )}
                />
                {getFormErrorMessage("niche_topics")}
              </div>
            </div>
            <div className="form-row">
              <div className="form-col">
                <label className="form-label fw-bold">Do you have any unique expertise or personal experiences to share?</label>
                <InputTextarea
                  style={{ fontSize: "14px" }}
                  rows={6}
                  className="form-control p-inputtext-lg"
                  {...register("unique_expertise", { required: { value: true, message: "Unique Expertise is required" } })}
                  onChange={e => { setValue("unique_expertise", e.target.value); clearErrors("unique_expertise") }}
                  placeholder="Add your experiences here..." />
                {getFormErrorMessage("unique_expertise")}
              </div>
            </div>
            <div className='form-row'>
              <div className='form-col'>
                <label className="form-label fw-bold">Are you focused on education, entertainment, storytelling, or community building?</label>
                <Controller
                  name="content_focus"
                  control={control}
                  rules={{ required: "Please select a category" }}
                  render={({ field }) => (
                    <>
                      {myconst.getRadioOptions('content_focus').map((option: arr_type) => (
                        <div
                          key={option.value}
                          className="p-field-radiobutton d-flex align-items-center"
                        >
                          <RadioButton
                            inputId={'content_focus_other'}
                            value={option.value}
                            onChange={(e) => { field.onChange(e.value); clearErrors('content_focus') }}
                            checked={field.value === option.value}
                          />
                          <label className="ms-2 c-pointer" onClick={() => { field.onChange(option.value); clearErrors('content_focus') }} htmlFor={option.value}>{option.label}</label>
                          {option.label === 'Other' && content_focus_value === 'other' &&
                            <InputText style={{ fontSize: "14px" }} className="ms-4" {...register("content_focus_other")} />
                          }
                        </div>
                      ))}
                    </>
                  )}
                />
                {getFormErrorMessage("content_focus")}
              </div>
            </div>
          </div>
        </div>
        <div className='stepper-footer'>
          <div className='stepper-wrapper stepper-wrapper-ft ms-auto'>
            <div className='stepper-footer-inner'>
              <div className='stepper-footer-left'>
                <button type="button" disabled className="grey-outline-btn mr-2">{'<< First'}</button>
                <button type="button" disabled className="outline-active-btn">{'< Previous'}</button>
              </div>
              <div className='stepper-footer-right'>
                <button type="button" className="outline-active-btn mr-2" onClick={handleNextButton}>{`Next >`}</button>
                <button type="button" disabled={!isLinear} className="grey-outline-btn" onClick={goOnLast}>{'Last >>'}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StepOne